import React from 'react';
import { Link } from "react-router-dom";

const PortfolioItem = ({ portfolio }) => {
    return (
        <div className="rwt-card">
            <div className="inner">
                <div className="thumbnail">
                    <figure className="card-image">
                        <a href={portfolio.webLink} target="_blank">
                            {/* <Link to={process.env.PUBLIC_URL + `/portfolio-details/${portfolio.id}`}> */}
                            <img className="img-fluid" src={portfolio.portfolioThumbnail} alt="Portfolio-01" />
                            {/* </Link> */}
                        </a>
                    </figure>
                    {/* <Link to={process.env.PUBLIC_URL + `/portfolio-details/${portfolio.id}`} className="rwt-overlay"></Link> */}
                        <a href={portfolio.webLink} target="_blank" className="rwt-overlay"></a>
                </div>
                <div className="content">
                    <h5 className="title mb--10">
                        {/* <Link to={process.env.PUBLIC_URL + `/portfolio-details/${portfolio.id}`}> */}
                        <a href={portfolio.webLink} target="_blank">
                            {portfolio.title}
                        </a>
                        {/* </Link> */}
                    </h5>
                    {/* <span className="subtitle b2 text-capitalize">{portfolio.category}</span> */}
                </div>
            </div>
        </div>
    )
}
export default PortfolioItem;